import type { JourneyConfig } from '@r6digital/rapidstor-types/react/entities/Journey';

/** Merged into `journey` by the dev config modal. See docs/unit-filters.md. */
export const UNIT_FILTER_SAMPLE: Pick<JourneyConfig, 'variant' | 'unitFilters' | 'quickSizeFilters'> = {
    variant: 'standard-unit-listing',
    unitFilters: [
        { mode: 'include', price: { min: 50, max: 300 } },
        { mode: 'exclude', unitTypeNames: ['wine'], unitTypeNameMatch: 'contains' },
    ],
    quickSizeFilters: [
        { key: 'lockers', label: 'Lockers', filters: [{ mode: 'include', area: { max: 2 } }] },
        { key: 'ground', label: 'Ground floor', filters: [{ mode: 'include', floors: [0] }] },
        {
            key: 'parking',
            label: 'standardUnitListing:vehicle',
            filters: [{ mode: 'include', unitTypeNames: ['parking'], unitTypeNameMatch: 'contains' }],
        },
    ],
};
